/**
 * Email validation utilities
 */
export function validateEmail(str: string): boolean {
  const atSplit = str.split("@")
  if (atSplit.length !== 2) {
    return false
  }

  const dotSplit = atSplit[1].split(".")
  if (dotSplit.length < 2) {
    return false
  }

  return true
}

/**
 * Phone validation and formatting utilities
 */
const numbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]

// Normalizes user input to E.164 format: "650-291-5002" -> "+16502915002"
// Returns empty string if no digits found
export function toPhoneNumber(input: string): string {
  const digits = input.replace(/\D/g, "")
  return digits ? `+1${digits}` : ""
}

// validates that phone number string is of the format +16502915002
export function validatePhone(str: string): boolean {
  if (str.length !== 12) {
    return false
  }

  for (let i = 0; i < str.length; i += 1) {
    // first character must be +
    if (i === 0 && str[i] !== "+") {
      return false
    }

    // the rest must be numbers
    if (i > 0 && !numbers.includes(str[i])) {
      return false
    }
  }

  return true
}

// format +1########## -> (###) ###-####
export function formatPhone(phoneNumber: string) {
  if (!phoneNumber) {
    return ""
  }

  return `(${phoneNumber.slice(2, 5)}) ${phoneNumber.slice(
    5,
    8
  )}-${phoneNumber.slice(8, 12)}`
}
